function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "capacitor");

var SvgCapacitor = function SvgCapacitor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M412.2,147.52V112.81a12.51,12.51,0,0,1-.74,4.06,12.51,12.51,0,0,0,.74-4.06c0-24-69.94-43.39-156.2-43.39S99.8,88.86,99.8,112.81a12.77,12.77,0,0,0,.73,4.06,12.77,12.77,0,0,1-.73-4.06v34.72c0,7.11,6.24,13.88,17.35,19.87v19.44a8.52,8.52,0,0,1-4.6,7.63c-8.24,4.26-12.75,8.94-12.75,13.8V468.61c0,18.92,43.47,35,104.13,41C220.25,511.13,237.78,512,256,512s35.75-.87,52.07-2.43c60.66-6,104.13-22,104.13-41V208.27c0-4.86-4.51-9.55-12.75-13.8a8.52,8.52,0,0,1-4.6-7.63V167.4C406,161.41,412.2,154.64,412.2,147.52ZM305,154c13.63-1.25,26.46-3,38.14-5.17-10.82,2-22.56,3.72-35.08,5C307.08,153.87,306,153.9,305,154Zm88.82-20.78a68.71,68.71,0,0,0,6-3.47c-1.94,1.25-3.94,2.41-6,3.46Zm6.11-3.52a45.76,45.76,0,0,0,5-3.77A45.76,45.76,0,0,1,399.93,129.7Zm5.81-4.59a27,27,0,0,0,2.75-3A27,27,0,0,1,405.74,125.11Zm3.64-4.2a17.44,17.44,0,0,0,1.56-2.84A17.44,17.44,0,0,1,409.38,120.91Zm-17,13c-1.9,1-3.91,1.87-6,2.77q3.18-1.34,6-2.76Zm-7.55,3.4a196.81,196.81,0,0,1-29,8.85,197,197,0,0,0,29-8.84Zm-30.18,9.11q-5.32,1.22-11,2.29,5.7-1.07,11-2.28Zm-70.1,9-4.58.19Zm-80.64-1.68c-12.52-1.23-24.25-2.92-35.08-5,11.69,2.26,24.53,4,38.17,5.26-1-.1-2.08-.13-3.07-.23Zm23.51,1.68,4.57.19ZM103.5,122.12a27,27,0,0,0,2.75,3A27,27,0,0,1,103.5,122.12Zm-2.45-4.06a17.44,17.44,0,0,0,1.56,2.84A17.44,17.44,0,0,1,101.05,118.06Zm11.09,11.68c1.82,1.19,3.86,2.34,6,3.47A66.1,66.1,0,0,1,112.14,129.74Zm-5-3.82a45.76,45.76,0,0,0,5,3.77A45.76,45.76,0,0,1,107.14,125.92Zm61.25,22.8q-5.7-1.07-11-2.29,5.27,1.22,11,2.29Zm-12.2-2.55a196.81,196.81,0,0,1-29-8.85,196.31,196.31,0,0,0,29,8.85Zm-30.51-9.48c-2.13-.9-4.15-1.82-6-2.76,1.85.94,3.83,1.86,6,2.76Z",
    style: {
      fill: "#4482c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.2,112.81v34.72c0,7.11-6.24,13.88-17.35,19.87a209.86,209.86,0,0,1-63.09,18.14c-7.55,1.12-15.45,2.17-23.69,3l-104.14-.09c-37.66-3.65-68.64-11.28-86.78-21-11.11-6-17.35-12.76-17.35-19.87V112.81c0,18.92,43.47,35,104.13,41,16.32,1.57,33.85,2.43,52.07,2.43s35.75-.86,52.07-2.43C368.73,147.79,412.2,131.73,412.2,112.81Z",
    style: {
      fill: "#4482c3"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 112.81,
    rx: 156.2,
    ry: 43.39,
    style: {
      fill: "#bdc3c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.2,208.27c0,18.92-43.47,35-104.13,41H203.93c-60.66-6-104.13-22-104.13-41,0-4.86,4.51-9.55,12.75-13.8a8.52,8.52,0,0,0,4.6-7.63V167.4c18.14,9.72,49.12,17.35,86.78,21l104.14.09c8.24-.79,16.14-1.83,23.69-3a209.55,209.55,0,0,0,63.09-18.13V186.8a8.52,8.52,0,0,0,4.6,7.63C407.69,198.73,412.2,203.41,412.2,208.27Z",
    style: {
      fill: "#285680"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.07,153.77v355.8C291.75,511.13,274.22,512,256,512s-35.75-.87-52.07-2.43V153.77c16.32,1.57,33.85,2.43,52.07,2.43S291.75,155.34,308.07,153.77Z",
    style: {
      fill: "#ecf0f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.93,121.49a8.7,8.7,0,0,1-8.68-8.68V8.68a8.68,8.68,0,0,1,17.36,0V112.81a8.67,8.67,0,0,1-8.66,8.68Z",
    style: {
      fill: "#f0785a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.07,121.49a8.67,8.67,0,0,1-8.68-8.66V8.68a8.68,8.68,0,1,1,17.36,0V112.81a8.67,8.67,0,0,1-8.66,8.68Z",
    style: {
      fill: "#f0785a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.68,286.37H247.32A17.38,17.38,0,0,1,230,269V217a17.37,17.37,0,0,1,17.35-17.36h17.36A17.37,17.37,0,0,1,282,217v52A17.38,17.38,0,0,1,264.68,286.37ZM247.32,217v52h17.37V217Z",
    style: {
      fill: "#7f8c8d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.68,468.61H247.32A17.37,17.37,0,0,1,230,451.25V399.19a17.37,17.37,0,0,1,17.35-17.36h17.36A17.37,17.37,0,0,1,282,399.19v52.06A17.37,17.37,0,0,1,264.68,468.61Zm-17.36-69.42v52.06h17.37V399.19Z",
    style: {
      fill: "#7f8c8d"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCapacitor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/capacitor.2e32cae0.svg";
export { ForwardRef as ReactComponent };